import type { UiActionParameters } from '../parameters/ui-action'

import { createEvent, sample } from 'effector'

export type ContentActionContentType =
  | 'tv'
  | 'vod'
  | 'tvshow'
  | 'catchup'
  | 'event'
  | 'trailer'

export type ContentActionPayload = {
  contentId?: number | string
  contentType?: ContentActionContentType | null
  contentName?: string
  programName?: string
  routeName?: string
  uiElementType: 'button' | 'menu_option' | 'menu'
  uiElementName:
    | 'mark_as_watched'
    | 'unmark_as_watched'
    | 'remove_from_cw'
    | 'kebab_button'
    | 'content_context_menu'
    | 'details'
  actionName: 'tap' | 'dismiss'
}

export const contentAction = createEvent<ContentActionPayload>()
export type ContentActionUiActionParameters = UiActionParameters & {
  routeName?: string
}

export const contentActionTracked =
  createEvent<ContentActionUiActionParameters>()

sample({
  clock: contentAction,
  fn: (params): ContentActionUiActionParameters => ({
    contentId:
      params.contentId == null ? undefined : params.contentId.toString(),
    contentType:
      params.contentType == null ? undefined : String(params.contentType),
    contentName: params.contentName,
    programName: params.programName,
    routeName: params.routeName,
    uiElementType: params.uiElementType,
    uiElementName: params.uiElementName,
    actionName: params.actionName,
  }),
  target: contentActionTracked,
})
